import { Box, LinearProgress, Typography } from '@mui/material';
import { Result, calculateChildProgress } from '@synergetx/puppet-interview-types';
import { memo } from 'react';

interface Props {
    result?: Result;
}

/**
 * Progress only. The assessor used to be printed under the bar, which squeezed an email address
 * into a 150px column — and on the results table it was already there as its own `Assessor`
 * column, so it showed twice.
 */
function ResultProgress({ result }: Props) {
    // A device that has never been used has no result at all. A 0% bar would read as "started and
    // got nowhere", which is a different thing and the more alarming of the two.
    if (!result) {
        return (
            <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                —
            </Typography>
        );
    }

    const value = calculateChildProgress(result);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{ borderRadius: 5, height: 10, flexGrow: 1 }}
                aria-label={`Survey progress ${Math.round(value)}%`}
            />
            <Typography variant="body2" sx={{ minWidth: 36, textAlign: 'right' }}>
                {Math.round(value)}%
            </Typography>
        </Box>
    );
}

export default memo(ResultProgress);
